import * as z from 'zod';
export const FeedbackSchema = z.object({
    //  email: z.string().email('Enter a real email please.').optional(), // renders TextField
    message: z.string(),
});
export const HelpSchema = z.object({
    // email: z.string().email('Enter a real email please.'),
    message: z.string(),
});
